// ⚡️ ESCROW WORKS BOX: How Escrow Works section with category-specific steps
// Extracted from ChatPanel.js for better organization and reusability

import React from 'react';

const EscrowWorksBox = ({
  conversation,
  isDarkMode,
  dispatch,
  state
}) => {
  // Helper function to create step circles
  const stepCircle = (n) => (
    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-br from-red-500 to-red-600 text-white font-bold text-lg shadow">
      {n}
    </span>
  );

  // Text styling classes
  const stepTextClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const italicTextClass = isDarkMode ? 'text-gray-400' : 'text-gray-500';

  // Get category-specific steps
  const getCategorySteps = () => {
    const category = (conversation.category_name || '').toLowerCase();
    
    if (category.includes('youtube')) {
      return (
        <ol className="space-y-5 pl-2">
          <li className="flex items-start gap-4">
            <span>{stepCircle(1)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer make a purchase, the agent will notify the seller to add the agent's email address as the owner.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(2)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The seller designates the escrow agent as owner.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(3)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The escrow agent verifies everything and assigns manager rights to the buyer.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(4)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After 7 days, the escrow agent remove all the other managers and assigns primary ownership rights to the buyer{' '}
              <span className={`italic ${italicTextClass}`}>
                (7 days is the minimum amount of time required in order to assign a new primary owner in the control panel.)
              </span>
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(5)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After completing the transaction, the money is sent by the agent to the seller
            </span>
          </li>
        </ol>
      );
    } else if (category.includes('facebook')) {
      return (
        <ol className="space-y-5 pl-2">
          <li className="flex items-start gap-4">
            <span>{stepCircle(1)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer make a purchase, the agent will notify the seller assigns the escrow agent's page as the administrator.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(2)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the seller assigns the Escrow agent as a page administrator, the Escrow agent checks everything and removes other administrators.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(3)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              Then, Escrow agent adds buyer Facebook account as administrator.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(4)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The buyer must check and confirm it with the agent after logging into the Facebook page.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(5)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After confirming the buyer and then remove the agent's account and completing the transaction, the money will be sent by the agent to the seller.
            </span>
          </li>
        </ol>
      );
    } else if (category.includes('instagram')) {
      return (
        <ol className="space-y-5 pl-2">
          <li className="flex items-start gap-4">
            <span>{stepCircle(1)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer make a purchase, the agent will notify the seller to transfers login details and the original email account to the escrow agent.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(2)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The escrow agent checks everything, changes the login details.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(3)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After that, the login details are sent to the buyer by the agent.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(4)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer has logged into the account, checking the account and confirming it with the agent
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(5)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After completing the transaction, the money is sent by the agent to the seller
            </span>
          </li>
        </ol>
      );
    } else if (category.includes('tiktok')) {
      return (
        <ol className="space-y-5 pl-2">
          <li className="flex items-start gap-4">
            <span>{stepCircle(1)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer make a purchase, the agent will notify the seller to transfers login details and the original email account to the escrow agent.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(2)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The escrow agent checks everything, changes the login details.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(3)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After that, the login details are sent to the buyer by the agent.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(4)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer has logged into the account, checking the account and confirming it with the agent
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(5)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After completing the transaction, the money is sent by the agent to the seller
            </span>
          </li>
        </ol>
      );
    } else {
      // Default: YouTube steps
      return (
        <ol className="space-y-5 pl-2">
          <li className="flex items-start gap-4">
            <span>{stepCircle(1)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After the buyer make a purchase, the agent will notify the seller to add the agent's email address as the owner.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(2)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The seller designates the escrow agent as owner.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(3)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              The escrow agent verifies everything and assigns manager rights to the buyer.
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(4)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After 7 days, the escrow agent remove all the other managers and assigns primary ownership rights to the buyer{' '}
              <span className={`italic ${italicTextClass}`}>
                (7 days is the minimum amount of time required in order to assign a new primary owner in the control panel.)
              </span>
            </span>
          </li>
          <li className="flex items-start gap-4">
            <span>{stepCircle(5)}</span>
            <span className={`${stepTextClass} text-base font-medium`}>
              After completing the transaction, the money is sent by the agent to the seller
            </span>
          </li>
        </ol>
      );
    }
  };

  return (
    <div className="w-full">
      <div className={`rounded-2xl shadow-xl p-8 mt-4 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${
        isDarkMode 
          ? 'bg-gradient-to-br from-[#1a1a1a] via-[#0f0f0f] to-[#1a1a1a] border border-red-800/50' 
          : 'bg-gradient-to-br from-red-50 via-white to-gray-50 border border-red-100'
      }`}>
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-red-500 to-red-600 shadow-md">
              <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24">
                <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
              </svg>
            </div>
            <span className={`font-extrabold text-2xl tracking-tight ${
              isDarkMode ? 'text-white' : 'text-gray-800'
            }`}>How Escrow Works</span>
          </div>
          
          {/* Collapse Button */}
          <button
            onClick={() => dispatch({ type: 'TOGGLE_BOX_COLLAPSE', payload: 'escrowWorks' })}
            className={`p-2 rounded-lg transition-all duration-200 ${
              isDarkMode 
                ? 'hover:bg-gray-700 text-gray-300' 
                : 'hover:bg-gray-100 text-gray-600'
            }`}
            aria-label="Toggle escrow works details"
          >
            <svg className={`w-5 h-5 transition-transform duration-200 ${
              state.collapsedBoxes.escrowWorks ? 'rotate-180' : ''
            }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
        
        {/* Collapsible Content */}
        <div className={`transition-all duration-300 overflow-hidden ${
          state.collapsedBoxes.escrowWorks ? 'max-h-0 opacity-0' : 'max-h-96 opacity-100'
        }`}>
          {getCategorySteps()}
        </div>
      </div>
    </div>
  );
};

export default EscrowWorksBox;
